import { useCallback } from 'react';
import { ControlsCommonProps } from '../../fields';
import { AttachmentResponse, FileResponse, InsertAttachmentRequest } from 'services/tenantManagementService';
import { useItems } from './useItems';
import { ColumnContainer, RowContainer } from 'components/Layout';
import { AddAttachmentButton } from './AddAttachmentButton';

export type AttachmentProps = ControlsCommonProps<InsertAttachmentRequest[]> & {
	multiple?: boolean
	accept?: string

	oldAttachments?: AttachmentResponse[]
	removeOldAttachment?(attachmentId: number): Promise<void>
	downloadOldAttachment?(attachmentId: number): Promise<FileResponse>
	additionalInfoMap?: { [key: number]: string }
}

export const Attachment = ({
	value, // those are new attachments
	onChange,
	disabled,
	onBlur,
	multiple,
	accept,

	oldAttachments, // those are already on backend
	removeOldAttachment,
	downloadOldAttachment,
	additionalInfoMap
}: AttachmentProps) => {
	const removeNewAttachmentCallback = useCallback(
		(item: InsertAttachmentRequest) => {
			if (!value) {
				return;
			}

			const attachments = value.filter((attachment) => attachment !== item);
			onChange && onChange(attachments);
		},
		[value, onChange]
	)

	const itemsContent = useItems(value, oldAttachments, disabled, additionalInfoMap, removeNewAttachmentCallback, removeOldAttachment, downloadOldAttachment);

	return (
		<ColumnContainer margin='small'>
			{!disabled &&
				<AddAttachmentButton
					value={value}
					onChange={onChange}
					disabled={disabled}
					onBlur={onBlur}
					multiple={multiple}
					accept={accept}
				/>
			}
			<RowContainer>
				{itemsContent}
			</RowContainer>
		</ColumnContainer>
	)
}
